import React from 'react';
import { Button } from '../../components/ui/button';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../../components/ui/accordion';
import { Save } from 'lucide-react';
import { defaultContactContent } from '../../siteContent';
import { useCms, Text, ImageField } from './cmsShared';

const AdminContentContact = () => {
  const { content: c, update, uploadImage, save, saving } = useCms('contact', defaultContactContent);
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div><h2 className="font-heading text-xl font-bold text-[#003366]">Contact Page — Content</h2>
        <p className="text-sm text-gray-500">Edit hero, form text, all contact details and the map image.</p></div>
        <Button onClick={save} disabled={saving} data-testid="cms-contact-save-btn" className="rounded-full bg-[#E74C3C] hover:bg-[#C0392B]"><Save className="w-4 h-4 mr-2" />{saving ? 'Saving…' : 'Save Changes'}</Button>
      </div>
      <Accordion type="multiple" defaultValue={['hero', 'details']} className="space-y-2">
        <AccordionItem value="hero" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger data-testid="cms-contact-section-hero">Hero & Form</AccordionTrigger>
          <AccordionContent>
            <Text label="Hero title" value={c.hero.title} onChange={(v) => update(['hero', 'title'], v)} testid="cms-contact-hero-title" />
            <Text label="Hero subtext" value={c.hero.subtext} onChange={(v) => update(['hero', 'subtext'], v)} area />
            <Text label="Form heading" value={c.formHeading} onChange={(v) => update(['formHeading'], v)} />
            <Text label="Form subtext" value={c.formSubtext} onChange={(v) => update(['formSubtext'], v)} area />
            <Text label="Info heading" value={c.infoHeading} onChange={(v) => update(['infoHeading'], v)} />
            <Text label="Info text" value={c.infoText} onChange={(v) => update(['infoText'], v)} area />
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="details" className="border rounded-xl px-4 bg-white">
          <AccordionTrigger data-testid="cms-contact-section-details">Contact Details & Map</AccordionTrigger>
          <AccordionContent>
            <Text label="Office address" value={c.office} onChange={(v) => update(['office'], v)} area />
            <Text label="Phone" value={c.phone} onChange={(v) => update(['phone'], v)} />
            <Text label="Email" value={c.email} onChange={(v) => update(['email'], v)} />
            <Text label="Working hours" value={c.hours} onChange={(v) => update(['hours'], v)} area />
            <ImageField label="Map / office image" value={c.mapImage} onChange={(v) => update(['mapImage'], v)} onUpload={(f) => uploadImage(['mapImage'], f)} testid="cms-contact-map-image" />
          </AccordionContent>
        </AccordionItem>
      </Accordion>
      <div className="flex justify-end mt-6"><Button onClick={save} disabled={saving} className="rounded-full bg-[#E74C3C] hover:bg-[#C0392B]"><Save className="w-4 h-4 mr-2" />{saving ? 'Saving…' : 'Save Changes'}</Button></div>
    </div>
  );
};

export default AdminContentContact;
